import { useEffect, useState } from 'react';
import { onToast, type Toast } from '../toast.js';

/** Shows the current confirmation over whatever screen is up. */
export function Toaster() {
  const [current, setCurrent] = useState<Toast | null>(null);
  useEffect(() => {
    onToast(setCurrent);
    return () => {
      onToast(null);
    };
  }, []);
  if (current === null) return null;
  return (
    <div className="toast-wrap" role="status" aria-live="polite">
      <div className={`toast ${current.kind}`} key={current.id} data-testid="toast">
        <svg className="toast-mark" viewBox="0 0 24 24" aria-hidden="true">
          <circle cx="12" cy="12" r="10.5" />
          {current.kind === 'ok' ? (
            <path d="M7 12.5l3.2 3.2L17 9" />
          ) : (
            <path d="M8 8l8 8M16 8l-8 8" />
          )}
        </svg>
        <span>{current.text}</span>
      </div>
    </div>
  );
}
